import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Make sure this is imported in App.js or index.html for global styling
import { BACKEND_URL } from '../../../Constants';

const StudentQuizzes = () => {
    const [quizScores, setQuizScores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const studentId = localStorage.getItem('userId'); // Get the current student's ID from localStorage

    useEffect(() => {
        const fetchStudentQuizScores = async () => {
            if (!studentId) {
                setError("Student ID not found. Please log in.");
                setLoading(false);
                return;
            }

            setLoading(true);
            setError(null);
            try {
                // Use the new student-specific API route
                const response = await axios.get(`${BACKEND_URL}/api/enrollments/student/${studentId}/quiz-scores`);
                setQuizScores(response.data);
            } catch (err) {
                console.error('Error fetching student quiz scores:', err);
                setError('Failed to load your quiz scores. Please check the server connection.');
                toast.error('Failed to load your quiz scores.');
            } finally {
                setLoading(false);
            }
        };

        fetchStudentQuizScores();
    }, [studentId]); // Re-run effect if studentId changes

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <p className="text-muted fs-5">Loading your quiz scores...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="alert alert-danger text-center" role="alert">
                    <strong className="font-weight-bold">Error!</strong>
                    <span className="d-block d-sm-inline"> {error}</span>
                </div>
            </div>
        );
    }

    if (!quizScores || quizScores.length === 0) {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center vh-100">
                <p className="text-muted fs-5">No quiz scores found for your account.</p>
            </div>
        );
    }

    return (
        <div className="container py-4">
            <h2 className="text-dark mb-4">My Quiz Scores</h2>
            <div className="card shadow-sm">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead className="bg-light">
                                <tr>
                                    <th scope="col" className="text-start text-uppercase text-muted small">Course Title</th>
                                    <th scope="col" className="text-start text-uppercase text-muted small">Quiz Title</th>
                                    <th scope="col" className="text-start text-uppercase text-muted small">Score</th>
                                    <th scope="col" className="text-start text-uppercase text-muted small">Max Score</th>
                                    <th scope="col" className="text-start text-uppercase text-muted small">Percentage</th>
                                    <th scope="col" className="text-start text-uppercase text-muted small">Date Taken</th>
                                </tr>
                            </thead>
                            <tbody>
                                {quizScores.map((score, index) => (
                                    <tr key={index}>
                                        <td className="align-middle">{score.courseTitle}</td>
                                        <td className="align-middle">{score.quizTitle}</td>
                                        <td className="align-middle">{score.score}</td>
                                        <td className="align-middle">{score.maxScore}</td>
                                        <td className="align-middle">
                                            {score.maxScore > 0 ? `${((score.score / score.maxScore) * 100).toFixed(2)}%` : 'N/A'}
                                        </td>
                                        <td className="align-middle">{new Date(score.dateTaken).toLocaleDateString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={2000} />
        </div>
    );
};

export default StudentQuizzes;
